import React from "react";
import { parsePubmedIds, pubmedUrl } from "./usePubmedValidator";

const STATUS = {
  valid:    { label: "Valid",         color: "#16a34a", dot: "●" },
  invalid:  { label: "Not found",     color: "#dc2626", dot: "●" },
  checking: { label: "Checking…",     color: "#9ca3af", dot: "◌", spin: true },
  unknown:  { label: "Network error", color: "#d97706", dot: "●" },
};

export default function PubmedIdField({
  label,
  name,
  value,
  onChange,
  onBlur,
  validity = {},
  placeholder = "e.g., 12345678, 23456789",
  required = false,
  error = false,
}) {
  const ids = parsePubmedIds(value);
  const hasIds = ids.length > 0;

  return (
    <>
      <label htmlFor={name} className="pubmed-field-label">
        {label}
        {required && <span className="required"> *</span>}
      </label>

      <div className="pubmed-field-wrapper">
        <input
          id={name}
          type="text"
          name={name}
          value={value ?? ""}
          onChange={onChange}
          onBlur={() => onBlur?.(name, value)}
          placeholder={placeholder}
          className={error ? "input-error" : ""}
          autoComplete="off"
        />

        {!hasIds && (
          <span className="pubmed-hint">
            Separate multiple IDs with commas. Links appear as you type.
          </span>
        )}

        {hasIds && (
          <div className="pubmed-links-row">
            {ids.map((id) => {
              const st = validity[id];
              const badge = STATUS[st];

              return (
                <span key={id} className={`pubmed-chip pubmed-chip--${st || "idle"}`}>
                  <a
                    href={pubmedUrl(id)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="pubmed-chip__link"
                    title={`Open PubMed record ${id}`}
                  >
                    PMID&nbsp;{id}&nbsp;↗
                  </a>

                  {badge && (
                    <span
                      className={`pubmed-chip__badge${badge.spin ? " pubmed-chip__badge--spin" : ""}`}
                      style={{ color: badge.color }}
                      title={badge.label}
                    >
                      {badge.dot}&nbsp;{badge.label}
                    </span>
                  )}

                  {!badge && (
                    <span className="pubmed-chip__badge pubmed-chip__badge--idle">
                      Tab to verify
                    </span>
                  )}
                </span>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
}